export function Header() {
  return (
    <div className="font-bold text-[42px] p-10">
      <h1 className="">eden momchilov</h1>
      <div></div>
    </div>
  );
}
